import { Component, inject, signal } from "@angular/core";
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { AbstractListController } from 'src/app/common/abstract-list.component';
import { Bookings } from 'src/app/models/bookings';
import { BookingsService } from 'src/app/services/bookings.service';
import { PARAM_EMPLOYEES_PATH } from '../../constants/constants';
import { Employees } from 'src/app/models/employees';
import { EmployeesService } from 'src/app/services/employees.service';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { SlicePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { InitialsAvatarComponent } from '../../components/initials-avatar/initials-avatar.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { Card } from 'primeng/card';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';

import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-manage-employees',
    templateUrl: './manage-employees.component.html',
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, ButtonDirective, TopNavComponent, RouterLink, TableModule, InitialsAvatarComponent, NgxPaginationModule, Card, ConfirmDialog, Toast, SlicePipe, TranslatePipe]
})
export class ManageEmployeesComponent extends AbstractListController<Employees, any> {
  protected bookingsService = inject(BookingsService);
  private employeesService: EmployeesService;
  protected confirmationService: ConfirmationService;

  title = 'Appuntamenti';
  readonly cols = signal<any[]>(undefined);
  readonly columnOptions = signal<any[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  readonly roomDialog = signal<boolean>(false);
  booking: Bookings;
  readonly employee = signal<Employees>(undefined);
  readonly selectedWorks = signal<any[]>(undefined);

  constructor() {
    const employeesService = inject(EmployeesService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(employeesService, confirmationService, router, route, PARAM_EMPLOYEES_PATH);
    this.employeesService = employeesService;
    this.confirmationService = confirmationService;

    this.cols.set([
      { field: "name", header: "Nome" },
      { field: "surname", header: "Cognome" },

      { field: "date", header: "Data di nascità" },
      { field: "phone", header: "Cellulare" },
      { field: "city", header: "Indirizzo" }
    ]);
    this.colsFilter.set([
      { field: "name", icon: "pi-user", header: "Nome", type: "string" },
      { field: "surname", icon: "pi-user", header: "Cognome", type: "string" },
      { field: "phone", icon: "pi-phone", header: "Cellulare", type: "string" },
      { field: "city", icon: "pi-map-marker", header: "Città", type: "string" },
    ]);


    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({ label: this.cols()[i].header, value: this.cols()[i] }); return [...a]; });
    }
  }



  edit(employee: Employees) {
    this.employee.set({ ...employee });

      this.selectedWorks.set(this.booking.works_id.split(','));
          this.roomDialog.set(true);
  }


}